import { Component, EventEmitter, Input, Output } from '@angular/core';
import { WEEKDAY_ABBR_LIST } from '../../../../app/lib/common/helper.lib';
import { IUIElement } from '../../uiElement.interface';
import { DailyRebootInfo } from './dailyReboot.data';

@Component({
    selector: 'na-dailyReboot',
    templateUrl: './dailyReboot.component.html',
    styleUrls: ['../../uiElement.style.css', './dailyReboot.component.css'],
    standalone: false
})
export class DailyRebootComponent implements IUIElement {
    readonly WEEKDAY_ABBR_LIST: string[] = WEEKDAY_ABBR_LIST;
    readonly STAGGER_TIME_MIN: number = 0;
    readonly STAGGER_TIME_MAX: number = 1440;

    _info: DailyRebootInfo = new DailyRebootInfo();
    @Input('config')
    set config(config: any) {
        this._info = config instanceof DailyRebootInfo ? config : new DailyRebootInfo(config);
    }

    @Input('supportStagger') _supportStagger: boolean = false;
    @Input('showBorder') _showBorder: boolean = true;
    @Input('disabled') _disabled: boolean = false;
    @Input('unsupportReason') _unsupportReason: string;
    @Input('lock') _lockInfo: { isSync: boolean, policyID: string, policyName: string };

    @Output() onDataChanged = new EventEmitter<DailyRebootInfo>();

    enableFeature(checked: boolean): void {
        this._info.enable(checked);
        this.notify();
    }

    checkWeekday(weekdayId: string, checked: boolean): void {
        this._info.checkWeekday(weekdayId, checked);
        this.notify();
    }

    changeStaggerDuration(value: string): void {
        const num: number = Number(value);
        this._info.staggerRebootWithinMinutes = isNaN(num) ? 0 : Math.min(Math.max(num, this.STAGGER_TIME_MIN), this.STAGGER_TIME_MAX);
        this.notify();
    }

    onDailyRebootTimeChanged(time: string): void {
        this._info.time = time;
        this.notify();
    }

    notify(): void {
        this.onDataChanged.emit(this._info);
    }
}